import { Stack, Tooltip } from "@mui/material";
import { TDatagridChip } from "../../types";
import * as IconMui from "@mui/icons-material";
import { ChipStyle } from "./styles";

export const CreateChip: React.FC<TDatagridChip[]> = (chip) => {
  const parseLbl = (lbl: string) => {
    if (lbl.length > 6) {
      return lbl.substring(0, 6) + "...";
    } else {
      return lbl;
    }
  };

  const parseToolTip = (arr: TDatagridChip[]) => {
    let tooltip = "";
    arr.forEach((t) => {
      tooltip = tooltip + t.label + ", ";
    });
    return tooltip.slice(0, -2);
  };

  const createIcon = (id: number) => {
    const Icon = IconMui[chip[id].icon];
    return (
      <Icon
        style={{
          color: chip[id].bgColor === "#FFFFFF" ? "#000" : "#FFFFFF",
        }}
      />
    );
  };

  if (chip.length > 0) {
    return (
      <>
        <Tooltip key={chip[0].id} title={chip[0].label} arrow placement="top">
          <Stack direction="row" spacing={1}>
            <ChipStyle
              colorText={chip[0].bgColor === "#FFFFFF" ? "#000" : "#FFFFFF"}
              colorBg={chip[0].bgColor}
              avatar={createIcon(0)}
              label={parseLbl(chip[0].label)}
            />
          </Stack>
        </Tooltip>
        {chip[1] && (
          <Tooltip key={chip[1].id} title={chip[1].label} arrow placement="top">
            <Stack direction="row" spacing={1}>
              <ChipStyle
                colorText={chip[1].bgColor === "#FFFFFF" ? "#000" : "#FFFFFF"}
                colorBg={chip[1].bgColor}
                avatar={createIcon(1)}
                label={parseLbl(chip[1].label)}
              />
            </Stack>
          </Tooltip>
        )}
        {chip[2] && (
          <Tooltip
            key={chip[2].id}
            title={parseToolTip(chip)}
            arrow
            placement="top"
          >
            <Stack direction="row" spacing={1}>
              <ChipStyle
                colorText={chip[2].bgColor === "#FFFFFF" ? "#000" : "#FFFFFF"}
                colorBg={chip[2].bgColor}
                avatar={createIcon(2)}
                label={`+${chip.length - 1}`}
              />
            </Stack>
          </Tooltip>
        )}
      </>
    );
  }
};
